import { Theme } from '@mui/material';

export const sidebarStyles = {
  container: (theme: Theme, isOpen: boolean) => ({
    padding: 0,
    width: isOpen ? 240 : 65,
    backgroundColor: 'white',
    transition: 'width 0.3s ease',
    '& .MuiBox-root': {
      boxSizing: 'border-box'
    }
  }),

  sidebarItem: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    position: 'relative',
    cursor: 'pointer',
    color: 'inherit',
    height: '24px',
    boxSizing: 'content-box',
    '&:hover': {
      backgroundColor: '#f3f2f1',
    },
    '&.active': {
      backgroundColor: '#f3f2f1',
      borderLeft: '3px solid #007fc8',
    }
  },

  sidebarIcon: {
    position: 'absolute',
    width: '16px',
    height: '16px',
  },

  sidebarText: (isOpen: boolean) => ({
    marginLeft: '30px',
    fontSize: '14px',
    fontFamily: '\'Segoe UI\', Tahoma, Geneva, Verdana, sans-serif',
    fontWeight: 400,
    color: '#323130',
    whiteSpace: 'nowrap',
    display: isOpen ? 'block' : 'none',
  }),

  subSidebarItem: {
    paddingLeft: '0px !important',
    paddingTop: '8px !important',
    paddingBottom: '8px !important',
    display: 'block !important'
  },

  // spacer Styles
  spacer: {
    flexGrow: 1
  }
};

export const sidebarCssString = `
.sidebar-item {
  padding: 20px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  // height: 24px;
  box-sizing: content-box;
}

.sub-sidebar-item {
  padding-left: 0px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  display: block !important;
}

.sidebar-item:hover {
  background-color: #f3f2f1;
}

.sidebar-text {
  // margin-left: 30px;
  font-size: 14px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 400;
  color: #323130;
  white-space: nowrap;
}

.sidebar-icon {
  position: absolute;
  width: 18px;
  height: 18px;
}

.active {
  background-color: #f3f2f1;
  border-left: 3px solid #007fc8;
}

a {
  text-decoration: none;
}
`; 